ObjectUtils.define('KeyboardUtils', {

  enableDebug: 0,

  maybeGetEventData: function maybeGetEventData(event) {
    var character = this.getCharacter(event);
    var isCharacterKey = this.isCharacterKey(event);
    var keyCode = this.getCharacterCode(event);
    var isMetaKey = this.isMetaKey(event);

    var target = EventDelegater.getTarget(event);
    var isTextField = DOM.isTextField(target);
    var isInputEvent = (event.type === 'input' || event.type === 'propertychange');

    var canCancelEvent = this._canCancelKeyEvent(event);
    var shouldHandleEvent;
    // Check this first, so arrow keys work when text field is focused (e.g. dropdown search)
    if (canCancelEvent) {
      shouldHandleEvent = (event.type === 'keydown');
    } else if (isTextField) {
      shouldHandleEvent = isInputEvent;
    } else {
      shouldHandleEvent = (event.type === 'keyup');
    }

    this.enableDebug && Logger.log(this, 'Handling keyboard event', {
      type: event.type,
      shouldHandle: shouldHandleEvent,
      canCancel: canCancelEvent,
      isChar: isCharacterKey,
      char: character,
      keyCode: keyCode,
      isMetaKey: isMetaKey,
      isTextField: isTextField,
    });

    if (!shouldHandleEvent) {
      return null;
    }
    
    var shouldSubmitForm = (keyCode === KeyCode.ENTER && DOM.shouldSubmitOnEnter(target));

    var isEscapeKey = (keyCode === KeyCode.ESCAPE);

    var didValueChange = (isTextField && isInputEvent);
    // No longer necessary after switching to the `input` event
    // var didValueChange = this._didEventChangeInputValue(event);

    var eventData = {
      event: event,
      target: target,
      isMetaKey: isMetaKey,
      isCharacterKey: isCharacterKey,
      isEscapeKey: isEscapeKey,
      character: isCharacterKey ? character : null,
      keyCode: keyCode,
      didValueChange: didValueChange,
      shouldSubmitForm: shouldSubmitForm,
    };

    if (isTextField) {
      var inputValue = DOM.value(target);
      eventData.name = DOM.getAttribute(target, 'name');
      eventData.inputValue = inputValue;
      eventData.value = inputValue;
    }

    this.enableDebug && Logger.log(this, 'Delegating event', eventData);

    return eventData;
  },

  _canCancelKeyEvent: function _canCancelKeyEvent(event) {
    var keyCode = KeyboardUtils.getCharacterCode(event);
    return (
      keyCode === KeyCode.UP
      || keyCode === KeyCode.DOWN
      || keyCode === KeyCode.ENTER
      || keyCode === KeyCode.ESCAPE
    );
  },

  _didEventChangeInputValue: function _didEventChangeInputValue(e) {
    if (this.isMetaKey(e)) {
      return false;
    }

    var keyCode = this.getCharacterCode(e);

    return (
      (keyCode >= 48 && keyCode <= 57) // number keys
	  || (keyCode >= 65 && keyCode <= 90) // letter keys
	  || (keyCode >= 96 && keyCode <= 111) // numpad keys
	  || (keyCode >= 186 && keyCode <= 192) // ;=,-./` (in order)
	  || (keyCode >= 219 && keyCode <= 222) // [\]' (in order)
	  || keyCode === KeyCode.BACKSPACE
	  || keyCode === KeyCode.SPACE
	  || keyCode === KeyCode.DELETE
    );
  },

  // This is strictly alphabets
  isCharacterKey: function isCharacterKey(e) {
    if (this.isMetaKey(e)) {
      return false;
    }

    var code = this.getCharacterCode(e);
    return (
      (code >= 65 && code <= 90)  // a - z
      || (code >= 97 && code <= 122) // A - Z
      || code == 47                  // /
      || code == 63                  // ?
    );
  },

  getCharacterCode: function getCharacterCode(e) {
    return e.which || e.keyCode;
  },

  getCharacter: function getCharacter(e) {
    // Default seems to be upper case
    var character = String.fromCharCode(this.getCharacterCode(e));
    if (!e.shiftKey) {
      character = character.toLowerCase();
    }
    return character;
  },

  isShiftKey: function isShiftKey(e) {
    return e.shiftKey ? true : false;
  },

  isMetaKey: function isMetaKey(e) {
    // Don't use e.shiftKey here
    return (e.metaKey || e.ctrlKey) ? true : false; //  e.altKey;
  },

  isNavkey: function isNavkey(e) {
    switch (e.keyCode) {
      case KeyCode.TAB:
      case KeyCode.BACKSPACE:
      case KeyCode.LEFT:
      case KeyCode.RIGHT:
      case KeyCode.DELETE:
      case KeyCode.ESCAPE:
      case KeyCode.UP:
      case KeyCode.DOWN:
      case KeyCode.HOME:
      case KeyCode.END:
      case KeyCode.ENTER:
      return true;
      default:
      return false;
    }
  },

  isNumericKey: function isNumericKey(e) { 
    return this._matchesCharacter(e, /[\d\.,]/); 
  },

  _matchesCharacter: function _matchesCharacter(e, regex) {
    var c = this.getCharacter(e);
    return regex.test(c);
  }
});
